import { Link } from 'react-router-dom';

interface VideoCardProps {
  id: string;
  title: string;
  thumbnail: string;
  rating: number;
  year: number;
  duration: string;
  tags: string[];
  views: string;
  isHot?: boolean;
  isNew?: boolean;
}

export default function VideoCard({
  id,
  title,
  thumbnail,
  rating,
  year,
  duration,
  tags,
  views,
  isHot,
  isNew,
}: VideoCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group block rounded-xl overflow-hidden bg-background-100 hover:bg-background-200/70 transition-all cursor-pointer"
    >
      <div className="relative aspect-video overflow-hidden">
        <img
          src={thumbnail}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
          loading="lazy"
        />
        <div className="absolute top-2 left-2 flex items-center gap-1.5">
          {isHot && (
            <span className="px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
              热门
            </span>
          )}
          {isNew && (
            <span className="px-2 py-0.5 bg-accent-500 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
              新上
            </span>
          )}
        </div>
        <div className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/60 text-background-50 text-xs rounded">
          {duration}
        </div>
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors flex items-center justify-center">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50 opacity-0 group-hover:opacity-100 transition-all transform scale-75 group-hover:scale-100">
            <i className="ri-play-fill text-xl"></i>
          </div>
        </div>
      </div>

      <div className="p-3 md:p-4">
        <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1.5 line-clamp-2 leading-snug">
          {title}
        </h3>
        <div className="flex items-center gap-3 text-xs text-foreground-500 mb-2">
          <span className="flex items-center gap-1">
            <span className="w-3.5 h-3.5 flex items-center justify-center">
              <i className="ri-star-fill text-secondary-500"></i>
            </span>
            {rating}
          </span>
          <span>{year}</span>
          <span>{views}</span>
        </div>
        <div className="flex flex-wrap gap-1">
          {tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="px-2 py-0.5 bg-background-200 text-foreground-600 text-xs rounded-md whitespace-nowrap"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}